import { useEffect, useState } from 'react';

import { hideLoginLoader } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import DOMPurify from 'dompurify';

import oktaAuth from '../../auth/oktaAuth';
import { GLOBALNAV_CONFIG } from '../../constants';
import { logger } from '../../logger';
import { fetchFromUrl, setAnalyticsEvents, updateSessionStorage } from '../../utilities';
import { BASED_URL_KEY } from '../../utilities/constants';
import { FOOD_ONBOARDING_URL } from '../constants';

export default function useConfig() {
  const [notificationConfig, setNotificationConfig] = useState(null);
  const [headerConfig, setHeaderConfig] = useState(null);
  const [redirectBaseUrl, setRedirectBaseUrl] = useState(false);
  const [page, setPage] = useState('');

  const urlParameters = window.location.search;
  const location = window.location.pathname;
  const isRC = location.includes(FOOD_ONBOARDING_URL);
  const cacheLangCountry = !isRC ? sessionStorage.getItem(BASED_URL_KEY) : '';

  const getConfig = async () => {
    try {
      const locale = updateSessionStorage.getItem('locale');
      const [configData, globalConfig] = await Promise.allSettled([
        fetchFromUrl(`${process.env.PUBLIC_URL}/models/${locale}/config.json`),
        fetchFromUrl(`${process.env.PUBLIC_URL}/models/${locale}/${GLOBALNAV_CONFIG}`)
      ]);
      const { notifications } = configData && configData.value;
      setNotificationConfig(notifications);
      setHeaderConfig(globalConfig && globalConfig.value);
    } catch (error) {
      setNotificationConfig(null);
      setHeaderConfig(null);
      logger.error('Error in getting Notifications/Global config', error);
    }
  };

  const setPrevUrl = () => {
    const currentURL = location.split('/pages/');
    if (cacheLangCountry && cacheLangCountry !== currentURL[0]) {
      const pageUrl = currentURL.pop();
      setRedirectBaseUrl(true);
      setPage(`${cacheLangCountry}/pages/${pageUrl}${urlParameters}`);
    }
  };

  const auth = async () => {
    const authenticated = await oktaAuth.isAuthenticated();
    hideLoginLoader(authenticated);
  };

  //   **
  // * Function to renew okta tokens
  // */
  // const refreshToken = () => {
  //   try {
  //     oktaAuth.session.refresh();
  //     oktaAuth.tokenManager.renew('accessToken');
  //     oktaAuth.tokenManager.renew('idToken');
  //   } catch (error) {
  //     logger.error('Failed trying to renew the token for the user', error);
  //   }
  // };

  // const setIdleTimeout = () =>
  //   new IdleJs({
  //     idle: Math.floor(21600 * 1000), // idle time in ms (currently, set to 6 hours)
  //     events: ['mousemove', 'keydown', 'mousedown', 'touchstart'], // events that will trigger the idle resetter
  //     onIdle: () => {
  //       // delete-api
  //       handleLogout();
  //     },
  //     onActive() {},
  //     onHide() {},
  //     onShow() {},
  //     keepTracking: true,
  //     startAtIdle: true
  //   });

  // const validateSession = () => {
  //   const autoRefresh = 1500;
  //   try {
  //     oktaAuth.session.exists().then(exists => {
  //       if (exists) {
  //         refreshToken();
  //         setInterval(() => {
  //           refreshToken();
  //         }, autoRefresh * 1000); // converting to millisecs
  //         // refresh the okta token every 25 min.
  //       }
  //     });
  //     setIdleTimeout().start();
  //   } catch (e) {
  //     logger.error('Error while validating the user session trying to refreshing its token', e);
  //   }
  // };

  // const shouldValidateSession = () => {
  //   if (!isRC) {
  //     validateSession();
  //   }
  // };

  useEffect(() => {
    if (!isRC) {
      setPrevUrl();
    } else {
      sessionStorage.removeItem(BASED_URL_KEY);
    }
  }, [cacheLangCountry]);

  useEffect(() => {
    getConfig(); // notification and header config
    setAnalyticsEvents();
    auth();
    // shouldValidateSession();
    oktaAuth.setOriginalUri(DOMPurify.sanitize(`${location}${urlParameters}`));
    sessionStorage.removeItem('referrerPath');
  }, []);
  return { notificationConfig, headerConfig, redirectBaseUrl, page };
}
